module.exports = __webpack_public_path__ + "static/img/son10_active.8b78fb6c.png";